module.exports = __webpack_public_path__ + "img/bg.1a28587a.png";